import { useGuestSiteSessionDataQuery } from './GuestSiteSessionData.graphql.generated';

type UseGuestSiteSessionDataArgs = Readonly<{
  skip?: boolean;
}>;

// PLAN-17 2B: canonical per-visitor session fetch. cache-and-network (not cache-first) so it
// always hits the network post-hydration with the auth token — the prewarm seeds a complete
// ANONYMOUS activeSession, so cache-first would never fetch the authenticated session. ssr:false;
// populates activeSession so cache-first GetEventCTAButtonsData/EWG read it. Gated on the flag.
export const useGuestSiteSessionData = (eventHandle: string | undefined, args?: UseGuestSiteSessionDataArgs) => {
  useGuestSiteSessionDataQuery({
    variables: { eventHandle: eventHandle ?? '' },
    batchMode: 'off',
    fetchPolicy: 'cache-and-network',
    ssr: false,
    skip: !eventHandle || args?.skip,
  });
};
